import React, { useState } from 'react';
import { Mail, Phone, User } from 'lucide-react';
import { motion } from 'framer-motion';
import Footer from './Footer';
import Header from './Header';
import { useDispatch, useSelector } from 'react-redux';
import { createRecord } from '../actions/createRecordSlice';


const ContactPage = () => {
  const dispatch = useDispatch();
  const { status, error } = useSelector((state) => state.contact);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission logic here (e.g., send data to backend or display confirmation)
    
    dispatch(createRecord({ formData, token: 'testtoken' })).then((action) => {
      if (action.type === 'contact/createRecord/fulfilled') {
        alert('Your message has been sent!');
        setFormData({
          name: '',
          email: '',
          phone: '',
          message: '',
        });
      } else {
        alert('Something went wrong. Please try again later.');
      }
    });
  };

  return (
    <div>
    <Header/>
    <div className="contact-container" style={{ maxWidth: '600px', margin: 'auto', padding: '20px' }}>
      <motion.h2
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1 }}
          className="about-title"
        >
          Contact Us
        </motion.h2>

      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{ textAlign: 'center', fontSize: '16px', marginBottom: '20px' }}
      >
        We’d love to hear from you! If you have any questions or comments, feel free to reach out to us using the form below.
      </motion.p>

      <motion.form
        onSubmit={handleSubmit}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
        style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <User />
          <input
            type="text"
            name="name"
            placeholder="Your Name"
            value={formData.name}
            onChange={handleChange}
            required
            style={{ padding: '10px', width: '100%' }}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Mail />
          <input
            type="email"
            name="email"
            placeholder="Your Email"
            value={formData.email}
            onChange={handleChange}
            required
            style={{ padding: '10px', width: '100%' }}
          />
        </div>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <Phone />
          <input
            type="text"
            name="phone"
            placeholder="Your Phone"
            value={formData.phone}
            onChange={handleChange}
            style={{ padding: '10px', width: '100%' }}
          />
        </div>
        <textarea
          name="message"
          placeholder="Your Message"
          value={formData.message}
          onChange={handleChange}
          required
          style={{ padding: '10px', width: '100%', height: '100px' }}
        />
        <motion.button
          type="submit"
          whileHover={{ scale: 1.1 }}
          style={{
            padding: '10px 20px',
            backgroundColor: '#4CAF50',
            color: 'white',
            border: 'none',
            cursor: 'pointer',
            borderRadius: '5px',
          }}
        >
          Send Message
        </motion.button>
      </motion.form>

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <p>Or send us an email directly at <a href="mailto:smartkidsprep25@gmail.com">smartkidsprep25@gmail.com</a></p>
      </div>
    </div>
    <Footer/>
    </div>


  );
};

export default ContactPage;
